// 商品画像拡大機能
  const zoomView = document.getElementById("sbnZoomView");
  const zoomWrapper = document.querySelector(".sbn-p-slider-template-product__main-wrapper");

  let currentTargetImage = null;

  //768px以上かどうか判定
  function isZoomEnabled() {
    return window.innerWidth >= 768;
  }

  // レンズ作成
  const lens = document.createElement("div");
  lens.className = "zoom-lens";
  zoomWrapper.appendChild(lens);

  // 現在のマウス座標を常に追跡
  let mouseX = 0;
  let mouseY = 0;
  window.addEventListener("mousemove", (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  // zoomView とレンズサイズを同期して更新
  function updateZoomViewAndLens() {
    if (!isZoomEnabled()) {
      zoomView.style.display = "none";
      lens.style.display = "none";
      return;
    }

    const screenWidth = window.innerWidth;
    let zoomWidth;

    if (screenWidth >= 1300) {
      zoomWidth = 500;
    } else if (screenWidth >= 1000) {
      zoomWidth = screenWidth - 750;
    } else {
      zoomWidth = 300;
    }

    zoomView.style.width = zoomWidth + "px";

    if (currentTargetImage) {
      const img = currentTargetImage;

      const bgSize = getComputedStyle(zoomView).backgroundSize.split(" ");
      const bgWidth = parseFloat(bgSize[0]);
      const bgHeight = parseFloat(bgSize[1]);

      const lensWidth = (zoomView.clientWidth * img.clientWidth) / bgWidth;
      const lensHeight = (zoomView.clientHeight * img.clientHeight) / bgHeight;

      lens.style.width = lensWidth + "px";
      lens.style.height = lensHeight + "px";

      lens.style.left = "0px";
      lens.style.top = "0px";
    }
  }

  // 初回設定 & resize時更新
  updateZoomViewAndLens();
  window.addEventListener("resize", updateZoomViewAndLens);

  // レンズ位置計算＋zoomView背景更新
  function handleZoomAtPoint(img, clientX, clientY) {
    if (!isZoomEnabled()) return;

    const rect = img.getBoundingClientRect();
    const x = clientX - rect.left;
    const y = clientY - rect.top;

    const lensWidth = parseFloat(lens.style.width);
    const lensHeight = parseFloat(lens.style.height);

    let lensLeft = x - lensWidth / 2;
    let lensTop = y - lensHeight / 2;

    const maxLeft = img.clientWidth - lensWidth;
    const maxTop = img.clientHeight - lensHeight;

    lensLeft = Math.min(Math.max(0, lensLeft), maxLeft);
    lensTop = Math.min(Math.max(0, lensTop), maxTop);

    lens.style.left = lensLeft + "px";
    lens.style.top = lensTop + "px";

    const xPercent = maxLeft === 0 ? 0 : (lensLeft / maxLeft) * 100;
    const yPercent = maxTop === 0 ? 0 : (lensTop / maxTop) * 100;

    zoomView.style.backgroundPosition = `${xPercent}% ${yPercent}%`;

    if (zoomView.style.display === "none") {
      zoomView.style.display = "block";
      lens.style.display = "block";
      updateZoomViewAndLens();
    }
  }

  // 画像に拡大イベントをバインド
  function bindZoomEvents(img) {
    if (!isZoomEnabled()) return;

    console.log('拡大開始', img);
    zoomView.style.backgroundImage = `url(${img.src})`;

    img.removeEventListener("mousemove", img._zoomHandler);

    const handler = (e) => handleZoomAtPoint(img, e.clientX, e.clientY);
    img.addEventListener("mousemove", handler);
    img._zoomHandler = handler;

    img.addEventListener("mouseleave", () => {
      zoomView.style.display = "none";
      lens.style.display = "none";
    });

    setTimeout(() => {
      if (!isZoomEnabled()) return;

      const rect = img.getBoundingClientRect();
      if (
        mouseX >= rect.left &&
        mouseX <= rect.right &&
        mouseY >= rect.top &&
        mouseY <= rect.bottom
      ) {
        handleZoomAtPoint(img, mouseX, mouseY);
      }
    }, 100);
  }

  // 指定スライドに拡大機能を設定
  function attachZoomToSlide(slide) {
    if (!isZoomEnabled()) return;
    if (!slide) return;

    const img = slide.querySelector("img.sbn-u-object");
    if (!img) return;

    if (currentTargetImage && currentTargetImage !== img) {
      currentTargetImage.removeEventListener("mousemove", currentTargetImage._zoomHandler);
      currentTargetImage._zoomHandler = null;
    }

    currentTargetImage = img;

    if (!img.complete) {
      img.onload = () => bindZoomEvents(img);
    } else {
      bindZoomEvents(img);
    }
  }

  // ページロード時 → 先頭スライド
  window.addEventListener("load", () => {
    if (!isZoomEnabled()) return;

    const firstSlide = document.querySelector(".sbn-p-slider-template-product__main-slide");
    attachZoomToSlide(firstSlide);
  });

  // Swiper slideChange → activeSlide
  setTimeout(() => {
    const swiperEl = document.querySelector(".sbn-p-slider-template-product__main-viewport");
    const existingSwiper = swiperEl?.swiper;

    if (existingSwiper) {
      existingSwiper.on("slideChangeTransitionEnd", () => {
        if (!isZoomEnabled()) return;

        const activeSlide = existingSwiper.slides[existingSwiper.activeIndex];
        attachZoomToSlide(activeSlide);
      });
    }
  }, 1000);